module.exports = __webpack_public_path__ + "icons.c8ddf1e5e5bf3682bc7bebf30f394148.woff";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.woff
// module id = 33
// module chunks = 0